import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { muiBankFill } from '@ally/metronome-icons';
import { Icon } from '../../Icon';
import { Space } from '../../Space';
import { TextBodyDEPRECATED } from '../../TypographyDEPRECATED';
const StyledContainer = styled.div `
  overflow: hidden;
  transition: height 0.35s;
  height: ${({ show }) => (show ? '40px' : '1px')};
  box-sizing: border-box;
`;
const StyledHolidayLegendWrapper = styled.div `
  display: flex;
  padding: 0 0 15px 25px;
  align-items: center;
`;
const HolidayLegend = ({ holidays }) => {
    const [displayedHolidays, setDisplayedHolidays] = useState('');
    useEffect(() => {
        setDisplayedHolidays(holidays.join(', '));
    }, [holidays, setDisplayedHolidays]);
    return (React.createElement(StyledContainer, { show: !!holidays.length },
        React.createElement(StyledHolidayLegendWrapper, null,
            React.createElement(Icon, { icon: muiBankFill, size: "md", fill: "slate-4", mr: "xs" }),
            React.createElement(Space, { mr: "xxs" },
                React.createElement(TextBodyDEPRECATED, { tag: "span", size: "sm", weight: "bold", color: "slate-4" }, "Federal Holidays:")),
            React.createElement(TextBodyDEPRECATED, { tag: "span", size: "sm", color: "slate-4" }, displayedHolidays))));
};
export { HolidayLegend };
//# sourceMappingURL=HolidayLegend.js.map